/* tslint:disable */
/* eslint-disable */
export enum JofiMembershipRolesEnum {
  Admin = 'ADMIN'
}
